import { ValueProvider } from '@angular/core';
import { ICON_PATH_TOKEN } from '@shared/ui-shared';

export const IconsPathProvider: ValueProvider = {
  provide: ICON_PATH_TOKEN,
  useValue: './libs/ui-forms/src/assets/icons',
};
